/*
 * @Descripttion:
 * @Author: panyufeng
 * @Date: 2024-09-29 15:27:43
 * @LastEditors: panyufeng
 * @LastEditTime: 2025-04-24 17:06:21
 */

import service from '@/utils/request'

// 列表数据查询
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: '/enterpriseViolationSetting/list',
    data: params
  })

// 违章转移api新增/编辑
export const updateSetting = (params: any) =>
  service.request({
    method: 'post',
    url: '/enterpriseViolationSetting/updateSetting',
    data: params
  })

// 违章转移修改状态
export const updateState = (params: any) =>
  service.request({
    method: 'post',
    url: '/enterpriseViolationSetting/updateState',
    data: params
  })

// 违章api交管平台列表
export const platforms = (params: any) =>
  service.request({
    method: 'post',
    url: '/enterpriseViolationSetting/platforms',
    data: params
  })
